// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sCTyD","tabsBox":"styles_tabsBox__SLad2","createButton":"styles_createButton__2Ciwf"};